import { Form, InputLabel, Space } from '@procurify/ui'

import { PriceFormField } from '@webapp/components/PriceField'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from '../messages'

interface TaxFieldsProps {
  taxTypeOptions: { label: string; value: string }[]
  isSubmitting: boolean
}

export const TaxFields = ({ taxTypeOptions, isSubmitting }: TaxFieldsProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space align='center' direction='horizontal' justify='end'>
      <Space.Item>
        <InputLabel htmlFor='taxAmount'>
          {intl.formatMessage(messages.taxAmountLabel)}
        </InputLabel>
      </Space.Item>
      <Space.Item width={1 / 3}>
        <PriceFormField
          id='taxAmount'
          name='taxAmount'
          disabled={isSubmitting}
          inputProps={{ style: { textAlign: 'right' } }}
        />
      </Space.Item>
      <Space.Item width={1 / 3}>
        <Form.Select
          id='taxType'
          name='taxType'
          options={taxTypeOptions}
          disabled={isSubmitting}
        />
      </Space.Item>
    </Space>
  )
}
